import { Component } from '@angular/core';

@Component({
  selector: 'customer-about-us',
  templateUrl: './customer-about-us.component.html',
  styleUrls: ['./customer-about-us.component.scss']
})
export class CustomerAboutUsComponent {

}
